module.exports = __webpack_public_path__ + "img/icon-remove-card-disabled.6a546cb8.svg";